import { StorageFindDto, type StorageFindInterface } from '@zaoblako/shared/modules/storage/dtos/storage/storage-find.dto';
import { StatFindDto, type StatFindInterface } from '@zaoblako/shared/modules/storage/dtos/stat/stat-find.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { StorageDtoKeyEnum } from '@zaoblako/shared/modules/storage/enums/storage-dto-key.enum';

import * as yup from 'yup';

/** S3 storage bucket response body - DTO signature */
export interface BucketFindInterface {
  /** Unique identifier. Cannot be changed. */
  id: string;

  // Tech fields
  /** Bucket creation date and time */
  created: Date;
  /** Bucket last update date and time */
  updated: Date;

  // Date fields
  /** Human-readable bucket name */
  name: string;
  /** Bucket path in S3 storage */
  path: string;
  /** Default bucket flag. Application can have only one default bucket. */
  isDefault?: boolean;

  // Relations
  /** Related storage data */
  storage: StorageFindInterface;
  /** Bucket statistics */
  stat?: StatFindInterface;
}

/** S3 storage bucket response body - DTO schema */
export const BucketFindDto = SerdeDtoClass.create<BucketFindInterface>(StorageDtoKeyEnum.BUCKET_FIND_DTO, {
  id: {
    sortable: true,
    label: 'Номер',
    hint: 'UUID',
    serializer: yup.string(),
  },
  created: {
    sortable: true,
    label: 'Создана',
    serializer: yup.date(),
  },
  updated: {
    sortable: true,
    label: 'Изменена',
    serializer: yup.date(),
  },
  name: {
    sortable: true,
    label: 'Название',
    serializer: yup.string(),
  },
  path: {
    label: 'Путь',
    serializer: yup.string(),
  },
  isDefault: {
    optional: true,
    label: 'Используется по-умолчанию',
    serializer: yup.boolean(),
  },
  storage: {
    sortable: true,
    optional: true,
    label: 'Хранилище',
    nested: StorageFindDto,
    serializer: (_, nested) => nested,
  },
  stat: {
    sortable: true,
    optional: true,
    nested: StatFindDto,
    label: 'Статистика по хранилищу',
    serializer: (_, nested) => nested,
  },
});
